import Level from '../level/level.vue';

export default {
    name: 'Stage',
    props: {
        selected_stage: Object,
    },
    components: {
        'level': Level,
    },
    computed: {
        
    },
    data() {
        return {
        };
    },
    methods: {
       
    },
    mounted() {

    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/club-standard/stage/stage.js